module.exports = __webpack_public_path__ + "static/img/logo.f129a49.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/views/download/logo.png
// module id = wWOj
// module chunks = 1 2 40